export const themeConfig = {
    token: {
      colorPrimary: '#4535CD',
      fontFamily: 'Outfit, sans-serif',
      colorText: "#1F1F1F",
    },
  };